import { authenticatedFetch } from '../../api/apiClient';

const BASE = '/api/v2/users/me/email-rem';

async function parseJson(respOrPromise) {
  const resp = await respOrPromise;
  if (!resp || typeof resp.json !== 'function') {
    throw new Error('Email Reminder API returned an unexpected response');
  }
  const data = await resp.json().catch(() => ({}));
  if (!resp.ok) {
    const err = new Error(data.error || data.message || `Request failed (${resp.status})`);
    err.detail = data.detail;
    err.status = resp.status;
    throw err;
  }
  return data.data ?? data;
}

function send(path, method, body) {
  const opts = { method };
  if (body !== undefined) {
    opts.headers = { 'Content-Type': 'application/json' };
    opts.body = JSON.stringify(body);
  }
  return parseJson(authenticatedFetch(`${BASE}${path}`, opts));
}

export const getEmailRemStatus = () => send('/status', 'GET');
export const listEmailRemTargets = () => send('/targets', 'GET');
export const listEmailRemAliases = () => send('/aliases', 'GET').then((d) => d.aliases || []);
export const createEmailRemAlias = (payload) => send('/aliases', 'POST', payload).then((d) => d.alias);
export const updateEmailRemAlias = (id, payload) => send(`/aliases/${id}`, 'PATCH', payload).then((d) => d.alias);
export const regenerateEmailRemAlias = (id) => send(`/aliases/${id}/regenerate`, 'POST').then((d) => d.alias);
export const deleteEmailRemAlias = (id) => send(`/aliases/${id}`, 'DELETE').then((d) => d.alias);
export const listEmailRemMeetings = () => send('/meetings', 'GET').then((d) => d.meetings || []);
export const cancelEmailRemMeeting = (id) => send(`/meetings/${id}/cancel`, 'POST').then((d) => d.meeting);
